<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewVendorForm = !showNewVendorForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewVendorForm, 'fa-minus-circle': showNewVendorForm }"></i>&nbsp;New Vendor</h6>
  <div class="card-body" [hidden]="!showNewVendorForm" style="max-height: 340px; overflow-y: scroll">
    <app-contact-vendor-form [contactId]="contactId" (saved)="formSaved($event)"></app-contact-vendor-form>
  </div>
</div>
<div class="text-center pt-2 pagination-small-margin pagination-center">
  <div class="float-right">
    <button type="button" title="Refresh" [disabled]="loadingVendors" (click)="loadVendors()" class="btn btn-outline-primary btn-sm">
      <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loadingVendors }"></i>
    </button>
  </div>
  <div class="float-left" *ngIf="count > (indexParams.per_page || 20)">
    <pagination
      [(ngModel)]="indexParams.page"
      [boundaryLinks]="true"
      [totalItems]="count"
      (pageChanged)="loadVendors($event.page)"
      class="pagination-sm"
      [itemsPerPage]="indexParams.per_page || 20"
      [maxSize]="3"
      previousText="&lsaquo;"
      nextText="&rsaquo;"
      firstText="&laquo;"
      lastText="&raquo;"
    ></pagination>
  </div>
  <div class="clearfix"></div>
</div>
<div class="pt-2"></div>
<table class="table table-striped table-sm">
  <tbody>
    <tr *ngFor="let vendor of vendors">
      <td *ngIf="!vendor.editing">
        <div class="row mt-1">
          <div class="col-1"></div>
          <div class="col-4 text-right">
            <small class="font-weight-bold">ID</small>
          </div>
          <div class="col-4">
            <small>{{ vendor.id }}</small>
          </div>
          <div class="col-3">
            <div class="float-right">
              <div class="btn-group btn-group-sm">
                <button type="button" (click)="vendor.editing = true" class="btn btn-sm btn-outline-primary" title="Edit">
                  <i class="fas fa-pencil-alt"></i>
                </button>
                <button type="button" (click)="deleteVendor(vendor)" class="btn btn-sm btn-outline-danger" title="Delete">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-1"></div>
          <div class="col-4 text-right">
            <small class="font-weight-bold">Account #</small>
          </div>
          <div class="col-7">
            <small>{{ vendor.account_number }}</small>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-1"></div>
          <div class="col-4 text-right">
            <small class="font-weight-bold">Description</small>
          </div>
          <div class="col-7">
            <small>{{ vendor.description }}</small>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-1"></div>
          <div class="col-4 text-right">
            <small class="font-weight-bold">Is a priority</small>
          </div>
          <div class="col-7">
            <small>{{ vendor.is_priority ? 'Yes' : 'No' }}</small>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-1"></div>
          <div class="col-4 text-right">
            <small class="font-weight-bold">Auto W/D</small>
          </div>
          <div class="col-7">
            <small>{{ vendor.is_auto_withdrawal ? 'Yes' : 'No' }}</small>
          </div>
        </div>
        <div class="pt-3"></div>
        <div class="row">
          <div class="col">
            <div class="row mt-1" *ngFor="let matter of vendor.matters">
              <div class="col-1"></div>
              <div class="col-9">
                <small>
                  <a [routerLink]="'/matters/' + matter.id">
                    {{ matter.name }}
                  </a>
                </small>
              </div>
              <div class="col-2">
                <small>
                  <button type="button" title="Remove Matter" (click)="removeMatter(matter.id, vendor.id)" class="btn btn-sm btn-outline-danger">
                    <i class="fas fa-trash"></i>
                  </button>
                </small>
              </div>
            </div>
            <div class="pt-1"></div>
            <div class="pb-1 border-top"></div>
            <div class="row">
              <div class="col">
                <div class="d-flex">
                  <div class="pr-1">
                    <label class="my-2">Add Matter</label>
                  </div>
                  <div class="flex-grow-1">
                    <app-matter-search [placeholder]="'Search and select'" [select_only]="true" [small_input]="true" (matter)="addMatter($event, vendor.id)"></app-matter-search>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
      <td *ngIf="vendor.editing">
        <h6 class="text-info font-italic card-title">Editing Vendor</h6>
        <app-contact-vendor-form [vendor]="vendor" (saved)="formSaved($event, vendor)"></app-contact-vendor-form>
      </td>
    </tr>
  </tbody>
</table>
<div class="pt-2"></div>
<div class="text-center pagination-small-margin pagination-center" *ngIf="count > (indexParams.per_page || 20)">
  <pagination
    [(ngModel)]="indexParams.page"
    [boundaryLinks]="true"
    [totalItems]="count"
    (pageChanged)="loadVendors($event.page)"
    class="pagination-sm"
    [itemsPerPage]="indexParams.per_page || 20"
    [maxSize]="3"
    previousText="&lsaquo;"
    nextText="&rsaquo;"
    firstText="&laquo;"
    lastText="&raquo;"
  ></pagination>
</div>
